import { Flex, Heading } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import PreviewTemplateChart from "../../../PlanTemplates/PreviewTemplateChart";
import RichTextViewer from "../../../RichTextArea/RichTextViewer";

const TargetedCanvasPreview = ({ measure, key1, key2 }) => {
  const { t } = useTranslation();

  return (
    <Flex direction="column">
      <Flex.Item>
        <Heading level="h3">{t("results.targetedCanvasAssessment")}</Heading>
      </Flex.Item>
      {(measure.description || measure.description_text) && (
        <Flex.Item margin="small 0 small large">
          <RichTextViewer
            value={measure.description || measure.description_text}
            ariaLabel={t("assessment.assignmentDesc")}
          />
        </Flex.Item>
      )}
      <Flex.Item overflowX="hidden" padding="small 0 small large">
        <PreviewTemplateChart
          bindto={"preview-section-" + key1 + "-measure-" + key2}
          masteryResults={"true"}
          title={t("assessment.masteryAvg")}
        />
      </Flex.Item>
      {measure.collecting_evidence && (
        <>
          <Flex.Item>
            <Heading level="h3">{t("assessment.canvasJuriedResults")}</Heading>
          </Flex.Item>
          <Flex.Item overflowX="hidden" padding="small 0 small large">
            <PreviewTemplateChart
              bindto={
                "preview-section-" + key1 + "-measure-" + key2 + "-juried"
              }
              masteryResults={"true"}
              title={t("assessment.masteryAvg")}
            />
          </Flex.Item>
          <Flex.Item margin="0 0 medium 0" padding="0 0 0 large">
            <RichTextViewer
              id={`preview-ja-findings-${key1}-${key2}`}
              label={
                <Heading level="h4">{t("juriedAssessment.findings")}</Heading>
              }
              value={t("results.findingsPreviewHtml")}
            />
          </Flex.Item>
          <Flex.Item padding="0 0 0 large">
            <RichTextViewer
              id={`preview-ja-recommendations-${key1}-${key2}`}
              label={
                <Heading level="h4">
                  {t("juriedAssessment.recommendations")}
                </Heading>
              }
              value={t("results.recommendationPreviewHtml")}
            />
          </Flex.Item>
        </>
      )}
    </Flex>
  );
};

export default TargetedCanvasPreview;
